import { Link } from 'react-router-dom'
import { BaseAdminListView } from '../smart_bps/admin/list_view'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/admin/base_view'
import { Paginator } from '../smart_bps/lib/components'
import { format_attr_value } from '../smart_bps/lib/utils'
import {AuthorizedDropDownMeny, UnauthorizedDropDownMenu} from "../lib/NavDropdownMenu";

export class AdminListView extends BaseAdminListView {
  renderContent() {
    let view = this

    function renderTh(attr_name) {
      const attr = view.props.attrs[attr_name]
      return <th key={attr_name}>{attr.title}</th>
    }

    function renderTr(row) {
      return <tr key={row.id}>
        {view.props.table_headers.map((attrName, idx) => {
          const attr = view.props.attrs[attrName]
          const value = format_attr_value(attr, row[attrName])
          return (
            <td key={attrName}>
              {idx === 0 ? <Link to={`/admin/${view.model_name}/${row.id}/`}>{value || "----"}</Link> : typeof value === 'boolean' ? <i className={`ti ti-${value && 'check text-success' || 'x text-danger'}`} /> : <>{value}</>}
            </td>
          )
        })}
      </tr>
    }

    if (this.props.list_items.length === 0) {
      return <div className="card mb-3">
        <div className="card-body p-3">
          Данные не найдены. Уточните условия отбора и поиска.
        </div>
      </div>
    }

    return [
      <div className="card mb-3" key="table">
        <div className="table-responsive text-nowrap">
          <table className='table table-sm'>
            <thead>
              <tr>
                {this.props.table_headers.map(renderTh)}
              </tr>
            </thead>
            <tbody className="table-border-bottom-0">
              {this.props.list_items.map(renderTr)}
            </tbody>
          </table>
        </div>
      </div>,

      <Paginator current_page={this.props.list_page}
        count_pages={this.props.list_count_pages}
        has_next={this.props.list_has_next_page}
        setPage={this.updateItems} key="paginator" />
    ]
  }

  renderTopPanelRightItems() {
    if (this.authorized) {
      return (
        <AuthorizedDropDownMeny
          userTitle={this.user_title}
          onLogout={this.logout}
        />
      )
    }
    return <UnauthorizedDropDownMenu/>
  }

  renderTopPanelLeftItems() {
    let { search_data } = this.props
    const items = super.renderTopPanelLeftItems().map(item => {
      return item.key === "search" ? null : item
    })

    const styleActive = Object.keys(search_data || {}).length ? { borderBottom: "2px solid rgb(255, 90, 0)", paddingBottom: "7px" } : {}

    return [
      ...items,
      <span className="me-2" key="search">
        <a data-bs-toggle="modal" data-bs-target="#modal_search" style={styleActive}>
          <i className="ti ti-search ti-xs me-1"></i>
          Поиск ({this.props.list_items_count})
        </a>
      </span>
    ]
  }
}

export default wrapView(AdminListView, stateToProps)
